module.exports = JSON.parse('{"welcome":{"toString":"welcome___25Dz2","header":{"toString":"welcome__header___23xlC"}}}', function (name, value) {
              return name !== 'toString' ? value : function () { return value };
            })